<template>
  <div class="garanties-list">
    <div class="clients__title">
      Assistances souscrites
    </div>

    <AssistancesFilter @submit="onFilterChanged" @assistanceDownloadCSV="downloadReport('csv')"
      @assistanceDownloadXLSX="downloadReport('xlsx')" />

    <template v-if="isLoading">
      <Preloader />
    </template>
    <template v-else>
      <div class="clients__table">
        <template v-if="garanties.data.length > 0">
          <div class="clients__table__item">
            <div class="clients__table__item--cell smaller">Numéro de contrat</div>
            <div class="clients__table__item--cell little_wider">Souscripteur</div>
            <div class="clients__table__item--cell smaller" v-if="representative_id">Assistance</div>
            <div class="clients__table__item--cell little_wider" v-else>Assistance</div>
            <div class="clients__table__item--cell little_wider">Option souscrite</div>
            <div class="clients__table__item--cell smaller">Date d'effet</div>
            <div class="clients__table__item--cell little_wider">Statut</div>
            <div class="clients__table__item--cell smaller">Etat de parc</div>
            <!--                        <div class="clients__table__item&#45;&#45;cell">Contrat</div>-->
          </div>
          <div class="clients__table__item" v-for='garanty in garanties.data'>
            <div class="clients__table__item--cell smaller wrong"
              v-if="garanty.status == 'Inactive' && garanty.status == 'Expired' || garanty.date_exit">
              {{ parseNumber(garanty) }}</div>
            <div class="clients__table__item--cell smaller" v-else>{{ parseNumber(garanty) }}</div>
            <div class="clients__table__item--cell little_wider wrong"
              v-if="garanty.status == 'Inactive' && garanty.status == 'Expired' || garanty.date_exit">
              {{ parseSouscripteurName(garanty) }}</div>
            <div class="clients__table__item--cell little_wider" v-else>{{ parseSouscripteurName(garanty) }}</div>
            <div class="clients__table__item--cell smaller wrong"
              v-if="garanty.status == 'Inactive' && garanty.status == 'Expired' || garanty.date_exit">
              {{ parseTypeGaranty(garanty) }}</div>
            <div class="clients__table__item--cell smaller" v-else>{{ parseTypeGaranty(garanty) }}</div>
            <div class="clients__table__item--cell little_wider wrong"
              v-if="garanty.status == 'Inactive' && garanty.status == 'Expired' || garanty.date_exit">
              {{ parseTypeOption(garanty) }}</div>
            <div class="clients__table__item--cell little_wider" v-else>{{ parseTypeOption(garanty) }}</div>
            <div class="clients__table__item--cell smaller wrong"
              v-if="garanty.status == 'Inactive' && garanty.status == 'Expired' || garanty.date_exit">
              {{ parseEffectiveDate(garanty) }}</div>
            <div class="clients__table__item--cell smaller" v-else>{{ parseEffectiveDate(garanty) }}</div>
            <div class="clients__table__item--cell little_wider wrong"
              v-if="garanty.status == 'Inactive' && garanty.status == 'Expired' || garanty.date_exit">
              {{ parseStatus(garanty) }}</div>
            <div class="clients__table__item--cell little_wider" v-else>{{ parseStatus(garanty) }}</div>
            <div class="clients__table__item--cell icon-cell smaller"><font-awesome-icon prefix="fas" icon="file-pdf"
                @click="show_parc_complete(garanty.id_devis ? garanty.id_devis : garanty.id)" /></div>
            <!--                        <div class="clients__table__item&#45;&#45;cell icon-cell">-->
            <!--                            <font-awesome-icon prefix="fas" icon="file-pdf" @click="preview_pdf('garantie/confirmation-pdf/' + garanty.id, '&show_type=stream')"/>-->
            <!--                        </div>-->
          </div>
        </template>
        <template v-else>
          <div class="subscribes-empty">Il n'y a aucune assistance concernant à cette recherche à ce jour.</div>
        </template>

      </div>

      <pagination v-if="representative_id" :data="garanties" @pagination-change-page="getRepresentativeGaranties"
        :limit="10">
      </pagination>
      <pagination v-else :data="garanties" @pagination-change-page="getGaranties" :limit="10"></pagination>
    </template>
  </div>
</template>


<script>
import AssistancesFilter from '@/components/GarantiesSouscrites/AssistancesFilter'
import Preloader from '@/components/Preloader'
import pdfPreviewMixin from '../../mixins/pdfPreviewMixin';

export default {
  name: "GarantiesAssistanceList",
  components: { AssistancesFilter, Preloader },
  mixins: [pdfPreviewMixin],
  data() {
    return {
      garanties: {
        data: []
      },
      filterParams: {
        pdf: 1,
      },
      sortParams: {
        sort: 'quote_number|desc',

      },
      isLoading: false,
    }
  },
  computed: {
    mechanic_id() {
      return this.$store.state.userInfo.mechanic ? this.$store.state.userInfo.mechanic.id : '';
    },
    representative_id() {
      return this.$store.state.userInfo.representative ? this.$store.state.userInfo.representative.id : '';
    },
  },
  watch: {
    'mechanic_id': function () {
      this.getGaranties();
    },
    'representative_id': function () {
      this.getRepresentativeGaranties();
    }
  },
  methods: {
    isDealer() {
      return this.$store.getters.isDealer;
    },
    isRepresentative() {
      return this.$store.getters.isRepresentative;
    },
    parseDate(garanty) {
      if (garanty && garanty.created_at) {
        let day = garanty.datesParse.day_created,
          month = garanty.datesParse.month_created,
          year = garanty.datesParse.year_created;
        return day + "/" + month + '/' + year;
      }

      return ' - ';
    },
    parseEffectiveDate(garanty) {
      if (garanty && garanty.effective_date) {
        let day = garanty.datesParse.day_effective,
          month = garanty.datesParse.month_effective,
          year = garanty.datesParse.year_effective;
        return day + "/" + month + '/' + year;
      }

      return ' - ';
    },
    parsePrice(garanty) {
      return (garanty && garanty.assistance_price) ? this.roundEURWithoutSymbol(garanty.assistance_price) + ' €' : ' - '
    },
    parseMechanicName(garanty) {
      return (garanty && garanty.mechanic && garanty.mechanic.garage) ? garanty.mechanic.garage : ' - ';
    },
    parseSouscripteurName(garanty) {
      if (garanty && garanty.client && typeof garanty.client.name_of_signatory === 'string') {
        const trimmed = garanty.client.name_of_signatory.trim();
        if (trimmed) {
          return trimmed;
        }
      }
      return ' - ';
    },
    parseNumber(garanty) {

      if (!garanty) {
        return ' - ';
      }

      if (garanty.customized_number) {
        return garanty.customized_number;
      }

      if (garanty.quote_number) {
        return garanty.quote_number;
      }

      return ' - ';
    },
    parseTypeGaranty(garanty) {
      if (garanty && garanty.type) {
        switch (+garanty.type) {
          case 1: return 'Autocars 9509'; break;
          case 2: return 'Poids Lourds 9510'; break;
          case 3: return 'VSL 9511'; break;
          case 4: return 'VU - VL 9512'; break;
          case 5: return 'VP-VUL - 4097'; break;
          default: return 'Autocars 9509'; break;
        }
      }

      return '';
    },
    parseStatus(garanty) {
      if (garanty && garanty.status) {
        if (!garanty.date_exit) {
          if (garanty.status == 'Active' || (this.$store.state.userInfo.representative.id == 15 && (garanty.status == 'Waiting_Payment' || garanty.status == 'Relance')))
            return 'Valide';
          else if (garanty.status == 'Inactive')
            return 'Résilié le ' + this.moment(garanty.cancellation_date).format('DD/MM/Y');
          else if (garanty.status == 'Resiliated')
            return 'Résilié le ' + this.moment(garanty.cancellation_date).format('DD/MM/Y');
          else if (garanty.status == 'Resiliated_Expired')
            return 'Résilié à l\'échéance';
          else if (garanty.status == 'Resiliated_Non_Payment')
            return 'Résilié le ' + this.moment(garanty.cancellation_date).format('DD/MM/Y') + ' pour non-paiement';
          else if (garanty.status == 'Resiliated_Sold')
            return 'Résilié le ' + this.moment(garanty.cancellation_date).format('DD/MM/Y') + ' pour vente';
          else if (garanty.status == 'Expired')
            return 'Echu';
          else if (garanty.status == 'Waiting_Payment')
            return 'Règlement en attente';
          else if (garanty.status == 'Relance')
            return 'Relance envoyée';
        }
        else
          return 'Véhicule sorti du parc le ' + this.moment(garanty.date_exit).format('DD/MM/Y');
      }
    },
    parseTypeOption(garanty) {
      if (garanty && garanty.type) {
        if (garanty.type == 1) {
          if (garanty.nb_vehicles_base && garanty.nb_vehicles_base > 0) {
            return 'Aucune';
          }
          else if (garanty.nb_vehicles_option1 && garanty.nb_vehicles_option1 > 0) {
            return 'Dépannage jusqu\'à 2500 €';
          }
          else if (garanty.nb_vehicles_option2 && garanty.nb_vehicles_option2 > 0) {
            return 'Dépannage jusqu\'à 4000 €';
          }
          else if (garanty.nb_vehicles_option3 && garanty.nb_vehicles_option3 > 0) {
            return 'Véhicule de remplacement jusqu\'à 500 € / jour';
          }
          else if (garanty.nb_vehicles_option4 && garanty.nb_vehicles_option4 > 0) {
            return 'Dépannage jusqu\'à 2500 € + Véhicule de remplacement jusqu\'à 500 € / jour';
          }
          else if (garanty.nb_vehicles_option5 && garanty.nb_vehicles_option5 > 0) {
            return 'Dépannage jusqu\'à 4000 € + Véhicule de remplacement jusqu\'à 500 € / jour';
          }
        }
        else if (garanty.type == 2) {
          if (garanty.nb_vehicles_base && garanty.nb_vehicles_base > 0) {
            return 'Aucune';
          }
          else if (garanty.nb_vehicles_option1 && garanty.nb_vehicles_option1 > 0) {
            return 'Dépannage jusqu\'à 2500 €';
          }
          else if (garanty.nb_vehicles_option2 && garanty.nb_vehicles_option2 > 0) {
            return 'Dépannage jusqu\'à 4000 €';
          }
        }
        else if (garanty.type == 3 || garanty.type == 5) {
          if (garanty.nb_vehicles_base && garanty.nb_vehicles_base > 0) {
            return 'Franchise 0 km + Dépannage 300 €';
          }
        }
        else if (garanty.type == 4) {
          if (garanty.nb_vehicles_base && garanty.nb_vehicles_base > 0) {
            return 'Dépannage 150 €';
          }
          else if (garanty.nb_vehicles_option1 && garanty.nb_vehicles_option1 > 0) {
            return 'Dépannage 300 €';
          }
          else if (garanty.nb_vehicles_option2 && garanty.nb_vehicles_option2 > 0) {
            return 'Franchise 0 km';
          }
        }
      }

      return '';
    },
    onFilterChanged(filterParams) {
      this.filterParams = filterParams;
      this.$nextTick(() => {
        if (this.representative_id) {
          this.getRepresentativeGaranties();
        }
        else {
          this.getGaranties();
        }
      });
    },
    getGaranties(page = 1) {
      this.isLoading = true;
      let url = 'garantie/assistance-search?page=' + page,
        data = {
          mechanic_id: this.mechanic_id,
          ...this.filterParams,
          ...this.sortParams
        };
      this.apiGet(url, data)
        .then(response => {
          this.isLoading = false;
          this.garanties = response.data;
        })
        .catch(error => {
          this.isLoading = false;
          console.log(error);
        })
    },
    getRepresentativeGaranties(page = 1) {
      this.isLoading = true;
      let url = 'mutuaide/representative-search?page=' + page,
        data = {
          representative_id: this.representative_id,
          ...this.filterParams,
          ...this.sortParams
        };
      this.apiGet(url, data)
        .then(response => {
          this.isLoading = false;
          this.garanties = response.data;
        })
        .catch(error => {
          this.isLoading = false;
          console.log(error);
        })
    },
    prepareDataForURL() {
      let pairs = [];
      let filters = this.filterParams;

      // Handle array-like filters if they exist
      for (let i in filters) {
        if (['start_date', 'end_date', 'full_name', 'quote_number', 'registration', 'representative_id'].includes(i) &&
          filters[i] && filters[i].length > 0) {
          pairs.push(`${i}=${encodeURIComponent(filters[i])}`);
        }
      }

      // Handle individual filter properties from filterParams
      filters.start_date ? pairs.push(`start_date=${filters.start_date}`) : null;
      filters.end_date ? pairs.push(`end_date=${filters.end_date}`) : null;
      filters.full_name ? pairs.push(`full_name=${filters.full_name}`) : null;
      filters.quote_number ? pairs.push(`quote_number=${filters.quote_number}`) : null;
      filters.registration ? pairs.push(`registration=${filters.registration}`) : null;

      // Add representative_id if it exists
      this.representative_id ? pairs.push(`representative_id=${this.representative_id}`) : null;

      return pairs.join('&');
    },
    downloadReport(type) {
      let url = `mutuaide/representative-quotes-download`;
      window.location = this.getApiAuthUrl(url) + `&` + this.prepareDataForURL() + `&representative_id=${this.representative_id}&type=${type}`;
    }
  },
  mounted() {
    if (this.representative_id) {
      this.getRepresentativeGaranties();
    }
    else {
      this.getGaranties();
    }
  }

}
</script>



// WEBPACK FOOTER //
// src/components/GarantiesSouscrites/GarantiesAssistanceList.vue